module.exports = __webpack_public_path__ + "static/media/linkDividing2.fb78a261.png";